import { render, staticRenderFns } from "./PxHistoricoPrecoProdutoMenu.vue?vue&type=template&id=516a68fb&scoped=true&"
import script from "./PxHistoricoPrecoProdutoMenu.vue?vue&type=script&lang=js&"
export * from "./PxHistoricoPrecoProdutoMenu.vue?vue&type=script&lang=js&"
import style0 from "./PxHistoricoPrecoProdutoMenu.vue?vue&type=style&index=0&id=516a68fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516a68fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VMenu,VTooltip})
